// extracted by mini-css-extract-plugin
export default {"audioPlayer":"MediaPlayer_audioPlayer__L8JpX","hidden":"MediaPlayer_hidden__I8UWH"};